module.exports = __webpack_public_path__ + "static/img/why_item.5578b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/why_item.png
// module id = KHYf
// module chunks = 171